module.exports = __webpack_public_path__ + "img/pr-3.5bee9e88.png";